import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export type VirtualTourCommentSignedUrlResponseData 
  = { viewUrls: { filename: string, signedUrl: string }[] };

export const useGetVirtualTourCommentAttachmentsQuery = 
  (commentId: string) => {
  const { authApi } = useAuth();
  const result = useQuery({
    queryKey: ["virtual-tour-comment-attachments-signed-urls", commentId],
    queryFn: async () => {
      const { data } = await authApi.get<VirtualTourCommentSignedUrlResponseData>(
        `/virtual-tour/annotation/comment/${commentId}/attachments`
      );
      return data;
    },
    staleTime: 1000 * 60 * 5,
    refetchInterval: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });

  return result;
};
